import React, { useRef } from 'react';
import { Button, DragAndDrop, IconSpinner, Modal } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import { useDispatch } from 'react-redux';
import { Field, Form as FinalForm } from 'react-final-form';
import { handleFileUpload } from '../../../../util/circleHelper';
import css from './CreatePostForm.module.css';
import IconCard from '../../../../components/SavedCardDetails/IconCard/IconCard';

const dragAndDropHandler = async (
  file,
  form,
  values,
  dispatch,
  onImageClick,
  formOldValues,
  setFormOldValues
) => {
  const imageUrl = await handleFileUpload(file, dispatch);
  if (formOldValues) {
    setFormOldValues({
      ...formOldValues,
      coverImage: imageUrl,
      coverImagefiles:  { file: file, signed_id: imageUrl?.signed_id },
    });
  } else {
    form.change(`coverImage`,imageUrl);
    form.change(`coverImagefiles`, { file: file, signed_id: imageUrl?.signed_id });
  }
  onImageClick();
};

const ImageFieldComponent = props => {
  const { form, values, inputRef, onImageClick, formOldValues, setFormOldValues } = props;
  const dispatch = useDispatch();
  return (
    <Field
      name="coverImage"
      component={() => {
        const onChange = async e => {
          const file = e.target?.files[0];
          const imageUrl = await handleFileUpload(file, dispatch);
          if (formOldValues) {
            setFormOldValues({
              ...formOldValues,
              coverImage: imageUrl,
              coverImagefiles: { file: file, signed_id: imageUrl?.signed_id },
            });
          } else {
            form.change(`coverImage`, imageUrl);
            form.change(`coverImagefiles`,  { file: file, signed_id: imageUrl?.signed_id });
          }
          onImageClick();
        };
        const inputProps = { accept: 'image/*', onChange, type: 'file' };
        return (
          <div style={{ display: 'none' }}>
            <input ref={inputRef} {...inputProps} />
          </div>
        );
      }}
    />
  );
};

const CoverImageUploadModal = props => {
  const {
    isImageModal,
    onImageClick,
    form,
    values,
    requestDirectUpload,
    formOldValues,
    setFormOldValues,
  } = props;
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const handleOpenFileInput = () => {
    inputRef.current.click(); // Trigger file input on button click
  };

  return (
    <div>
      <Modal
        id={'coverImageUploadModal'}
        isOpen={isImageModal}
        onClose={onImageClick}
        onManageDisableScrolling={manageDisableScrolling}
      >
        <div className={css.contentWrapper}>
          {requestDirectUpload ? (
            <div className={css.loader}>
              <IconSpinner type={true} />
            </div>
          ) : (
            <DragAndDrop
              handleDrop={files =>
                dragAndDropHandler(
                  files[0],
                  form,
                  values,
                  dispatch,
                  onImageClick,
                  formOldValues,
                  setFormOldValues
                )
              }
              acceptedFileType={'image'}
            >
              <div className={css.uploadWrapper}>
                <div className={css.headingName}>Attach image</div>
                <div className={css.boxUploader}>
                  <div className={css.plusIcon}>
                    <span className={css.icon}>
                      <IconCard brand="plus" />
                    </span>
                  </div>
                  <div className={css.dragText}>Drop your image here to attach them</div>
                  <Button
                    onClick={handleOpenFileInput}
                    type="button"
                    className={css.chooseFileButton}
                  >
                    Choose image
                  </Button>

                  <ImageFieldComponent
                    form={form}
                    values={values}
                    inputRef={inputRef}
                    onImageClick={onImageClick}
                    formOldValues={formOldValues}
                    setFormOldValues={setFormOldValues}
                  />
                </div>
              </div>
            </DragAndDrop>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default CoverImageUploadModal;
